import { render, staticRenderFns } from "./PolicyMainShort.vue?vue&type=template&id=96fe8704"
import script from "./PolicyMainShort.vue?vue&type=script&lang=js"
export * from "./PolicyMainShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports